import {
  FOOTBALL_DOWN_DISTANCE,
  FOOTBALL_FIELD_ZONE,
  FOOTBALL_TEAMS,
  FOOTBALL_SEASON,
  FOOTBALL_GAMES_ABBR_WITH_DATE,
  FOOTBALL_GAME_DATE,
  FOOTBALL_GAMES_WITH_CODE,
  FOOTBALL_FULL_ORG_WITH_DATE,
  FOOTBALL_GAME_NAME_SHORT_ABBR,
  FOOTBALL_GAME_NAME_SHORT_ABBR_DATE,
  FOOTBALL_GAME_SHORT_CODE,
  FOOTBALL_GAME_SHORT_CODE_DATE,
  FOOTBALL_GAME_SHORT_ORG,
  FOOTBALL_GAME_SHORT_ORG_DATE,
  GAME_ID,
} from './fields';

export const BREADCRUMB_BLACKLIST = [
  FOOTBALL_DOWN_DISTANCE,
  FOOTBALL_FIELD_ZONE,
  FOOTBALL_TEAMS,
  FOOTBALL_SEASON,
  FOOTBALL_GAMES_ABBR_WITH_DATE,
  FOOTBALL_GAME_DATE,
  FOOTBALL_GAMES_WITH_CODE,
  FOOTBALL_FULL_ORG_WITH_DATE,
  FOOTBALL_GAME_NAME_SHORT_ABBR,
  FOOTBALL_GAME_NAME_SHORT_ABBR_DATE,
  FOOTBALL_GAME_SHORT_CODE,
  FOOTBALL_GAME_SHORT_CODE_DATE,
  FOOTBALL_GAME_SHORT_ORG,
  FOOTBALL_GAME_SHORT_ORG_DATE,
  GAME_ID,
];
